import axios from 'axios';
import JWTinterceptor from "@/services/axios";

export async function sendPdfEmailService(email){
    try{
        const result = await JWTinterceptor.post(`send_mail/message`,
            {message: email}
        );
    return result;
    }catch(err){
        console.error("Send PDF Email Error:",err);
        throw err;
    }
}

export async function sendReportEmailService(chatId, type){
    try{
        const result = await JWTinterceptor.post(`send_mail/${chatId}/`, {
            file_type: type,
        });
        return result;
    }catch(err){
        console.error("Send Report Email Error:",err);
        throw err;
    }
}
export async function getSpecialtyList(){
    try {
        const response = await axios.get(`${process.env.VUE_APP_SOFA_API}getSpecialtyList`);
        return response.data;
    } catch (err) {
        console.error('Error fetching specialties:', err);
        throw err;
    }
}